import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LoadingScreen from "../LoadingScreen";


function PrivateRoute({ children }) {
  const { currentUser, isAdmin, isManager, loading } = useAuth();

  // Show loading screen when auth is still being processed
  if (loading) {
    return <LoadingScreen />;
  }

  // Only render children or redirect when loading is complete
  return currentUser && (isAdmin || isManager) ? (
    children
  ) : (
    <Navigate to="/access-account" replace />
  );
}

// Protect Auth Routes and redirect "/"
export function AuthRoute({ children }) {
  const { currentUser, loading } = useAuth();

  // Show loading screen when auth is still being processed
  if (loading) {
    return <LoadingScreen />;
  }

  // Only render children or redirect when loading is complete
  return currentUser ? <Navigate to="/" replace /> : children;
}

export default PrivateRoute;